/**
 * External dependencies
 */
import { includes } from 'lodash';
/**
 * Return true if platform is MacOS.
 *
 * @param {Window?} _window window object by default; used for DI testing.
 *
 * @return {boolean} True if MacOS; false otherwise.
 */

export function isAppleOS() {
  var _window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!_window) {
    if (typeof window === 'undefined') {
      return false;
    }

    _window = window;
  }

  var platform = _window.navigator.platform;
  return platform.indexOf('Mac') !== -1 || includes(['iPad', 'iPhone'], platform);
}
//# sourceMappingURL=platform.js.map